import platform from "../../../util/platform";
const create = (request) => {
    return (params) => {
        const path = `/app/auth/login`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, request);
    };
};
const intermediateAuth = {
    create
};
export default intermediateAuth;
